import React, { Component } from 'react'
import Section from '../shared/Section'
import SectionHeader from '../shared/Section/Header'
import Slides from './Slides'
import Stats from './Stats'

export class Features extends Component {
  baseClass = 'features'

  render() {
    return (
      <Section extraClasses={this.baseClass}>
        <SectionHeader
          title="Mosto makes communication & collaboration effortless"
          headline="Amazing features to convince you"
          description="Get all the features you need in one easy-to-use tool"
        />
        <Slides parentClass={this.baseClass} />
        <Stats parentClass={this.baseClass} />
      </Section>
    )
  }
}

export default Features
